import _find from 'lodash/find'

import * as mutationTypes from 'store/mutationTypes'
import * as actions from './actions'

export default {
  state: {
    toasts: [],
  },
  actions,
  mutations: {
    [mutationTypes.ADD_MINI_TOAST]: (state, toast) => {
      state.toasts.push(toast)
    },
    [mutationTypes.REMOVE_MINI_TOAST]: (state, toast) => {
      const foundToast = _find(state.toasts, {
        id: toast.id,
      })

      if (foundToast) {
        state.toasts.splice(state.toasts.indexOf(foundToast), 1)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/miniToasts/index.js